<script>
import { Bar } from 'vue-chartjs'
import axios from "axios";

export default {
  extends: Bar,
  data() {
    return {
      dashboard: [],
    }
  },
  mounted() {
    let authKey = window.$cookies.get("authKey");

    axios
        .get(process.env.VUE_APP_API_URL + 'authors/dashboard',{
          headers: {
            Authorization: 'Bearer ' + authKey
          }
        })
        .then((response) => {
          this.dashboard = response.data.model;

          this.renderChart(
              {
                labels: ['JAN', 'FEB', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],
                datasets: [{
                  barThickness: 20,
                  maxBarThickness: 20,
                  lineTension: 0,
                  borderWidth: 1,
                  borderColor: '#b9b9b9',
                  backgroundColor: '#b9b9b9',
                  data: [this.dashboard.totalYear.Jan, this.dashboard.totalYear.Feb, this.dashboard.totalYear.Mar, this.dashboard.totalYear.Apr, this.dashboard.totalYear.May, this.dashboard.totalYear.Jun, this.dashboard.totalYear.Jul, this.dashboard.totalYear.Aug, this.dashboard.totalYear.Sep, this.dashboard.totalYear.Oct, this.dashboard.totalYear.Nov, this.dashboard.totalYear.Dec]
                }]
              },
              {
                legend: { //hides the legend
                  display: false,
                },
                scales: {
                  yAxes: [{
                    display: false,
                    ticks: {
                      beginAtZero: true
                    },
                    gridLines: {
                      display: false
                    }
                  }],
                  xAxes: [{
                    display: true,
                    ticks: {
                      beginAtZero: true,
                      fontSize: 16,
                      fontStyle: 'bold',
                      fontColor: '#000',
                    },
                    gridLines: {
                      display: false
                    }
                  }]
                },
                tooltips: {
                  enabled: false,
                },
                responsive: true,
                maintainAspectRatio: false,
                height: 120,
              }
          )
        })
        .catch((e) => {
          this.errors.push(e);
        });
  }
};
</script>